
export class HhsgSharedSideNavMenuItem {
    label: string;
    name: string;
    route: string;
    subMenuItems?: HhsgSharedSideNavMenuItem[];
    queryParams?: any;
}